import {Pipe, PipeTransform} from '@angular/core';

/**
 * Entfernt HTML-Auszeichnungen aus einem Text und gibt reinen Text zurück.
 * Wird auf der Bestätigungsseite verwendet, wo Angebotstexte (z. B. "<h3>...</h3>")
 * laut Ticket nicht gerendert, sondern plain angezeigt werden sollen – anders als in
 * der Angebotsübersicht, wo das HTML bewusst gerendert wird.
 * SSR-sicher: arbeitet rein über Regex, kein DOM-Zugriff.
 */
@Pipe({
  name: 'stripHtml',
  standalone: true
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return value
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
}
